import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  IconButton,
  Slide,
  Divider,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

const ProspectSortMobile = ({
  openSortDrawer,
  setOpenSortDrawer,
  resetSortData,
  sortOrder,
  setSortOrder,
  handleSort,
  isTabPortrait,
}) => {
  const [activeField, setActiveField] = useState({});
  const sortOptions = [
    { id: "first_name", label: "Name & Title" },
    { id: "strengthData.strength", label: "JOI Strength" },
    { id: "primary_organization", label: "Organization & Location" },
    { id: "categories", label: "Industry/Sector" },
    { id: "suspect_status", label: "JOSF Status" },
  ];
  const handleFieldClick = (fieldId) => {
    setActiveField(fieldId === activeField ? null : fieldId);
  };

  const handleOrderChange = (fieldId, order) => {
    setSortOrder((prev) => ({ ...prev, [fieldId]: order }));
  };

  return (
    <Slide
      direction="left"
      in={openSortDrawer}
      mountOnEnter
      unmountOnExit
      className="aip-filter-mb-slide"
    >
      <Box
        sx={{
          position: "fixed",
          top: isTabPortrait ? "33px" : "0",
          left: isTabPortrait ? "" : "0",
          width: isTabPortrait ? "calc(100vw - 240px)" : "100vw",
          right: isTabPortrait ? "0px" : "",
          height: "100vh",
          bgcolor: "white",
          zIndex: 10,
          boxShadow: 2,
          display: "flex",
          flexDirection: "column",
          overflowX: "hidden",
          overflowY: "auto",
            pb: 20,

        }}
      >
        <div className="m-2">
          {/* Panel Header */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            py={1.5}
          >
            <IconButton onClick={() => setOpenSortDrawer(false)}>
              <ArrowBackIosNewIcon fontSize="small" />
            </IconButton>
            <Typography variant="subtitle1" fontWeight="bold">
              Sort
            </Typography>
            <Button
              sx={{ textTransform: "none", color: "royalblue" }}
              onClick={() => {
                setOpenSortDrawer(false);
                resetSortData();
              }}
            >
              Clear All
            </Button>
          </Box>
          <Divider />

          {/* Filter Items */}

          <Box>
            {sortOptions.map((option) => (
              <Box key={option.id} sx={{ mb: 2 }}>
                <Button
                  fullWidth
                  variant={activeField === option.id ? "contained" : "outlined"}
                  onClick={() => {
                    handleFieldClick(option.id);
                    handleSort(option.id);
                  }}
                  sx={{
                    justifyContent: "flex-start",
                    textTransform: "none",
                    fontWeight: "bold",
                    border: "none",
                    bgcolor:
                      activeField === option.id ? "#559CFF" : "transparent",
                    color: activeField === option.id ? "white" : "black",
                    "&:hover": {
                      border: "none",
                    },
                  }}
                >
                  {option.label}
                </Button>

                {activeField === option.id && (
                  <Box sx={{ mt: 1, pl: 2, textAlign: "center" }}>
                    <ToggleButtonGroup
                      value={sortOrder || ""}
                      exclusive
                      onChange={(e, newValue) => {
                        handleSort(option.id, newValue);
                      }}
                    >
                      <ToggleButton
                        value="asc"
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          border: "none",
                          "&.Mui-selected": {
                            bgcolor: "transparent",
                            color: "red",
                          },
                          "&.Mui-selected:hover": { bgcolor: "transparent" },
                        }}
                      >
                        Ascending
                      </ToggleButton>
                      <ToggleButton
                        value="desc"
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          border: "none",
                          "&.Mui-selected": {
                            bgcolor: "transparent",
                            color: "red",
                          },
                          "&.Mui-selected:hover": { bgcolor: "transparent" },
                        }}
                      >
                        Descending
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </Box>
                )}
              </Box>
            ))}
          </Box>
        </div>
      </Box>
    </Slide>
  );
};

export default ProspectSortMobile;
